import { Component, OnInit } from '@angular/core';

import { DatePipe } from '@angular/common';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ConnectionBackend } from '@angular/http';
import { BackendService } from 'app/shared/backend.service';
import CONFIG from 'config';
import { AuthService } from 'app/shared/auth.service';

import { NotificationService } from 'app/notification/notification.service';
//import { GroupAst } from '@angular/animations/browser/src/dsl/animation_ast';
import { Router } from '@angular/router';
import { AlertmessageService } from 'app/shared/alertmessage.service';
import { AppService } from 'app/app.service';

@Component({
  selector: 'app-accounttransfer',
  templateUrl: './accounttransfer.component.html',
  styleUrls: ['./accounttransfer.component.scss'],
  providers: [DatePipe]
})
export class AccounttransferComponent implements OnInit {
  //date = new FormControl(new Date(new Date().setDate(new Date().getDate())));
  date: any;
  asofdate: Date;
  //this.asofdate = new Date();
  //  this.date.setDate( this.date.getDate() + 3 );
  // maxDate=new Date(new Date().setDate(new Date().getDate()+7));
  minDate = new Date(new Date().setDate(new Date().getDate() + 1));
  maxDate = new Date(new Date().setDate(new Date().getDate() + 7));

  // minDate=new Date( this.asofdate + 1);
  dateFilter = (d: Date): boolean => {
    const day = d.getDay();
    const month = d.getMonth();
    // Prevent Saturday and Sunday from being selected.
    return day !== 0 && day !== 6;
  }
  weekOff(day) {
    console.log(day);
    //this.dateFilter(new Date());
    if (day == 5)
      this.date = new FormControl(new Date(new Date().setDate(new Date().getDate() + 3)));
    else if (day == 6)
      this.date = new FormControl(new Date(new Date().setDate(new Date().getDate() + 2)));
    else
      this.date = new FormControl(new Date(new Date().setDate(new Date().getDate() + 1)));
  }

  // date=new FormControl(new Date(new Date().setDate(new Date().getDate()+1)));

  serializedDate = new FormControl((new Date()).toISOString());
  today: any;
  tommarrow: any;
  holidayList: any;
  portfolioData: any;
  fromAccount: any;
  toAccount: any;
  currency: any;
  nameId: number;
  name: any;
  selectedAccBalanceList: any;
  toCurrentBalance: any;
  selectedAccBalance: any;
  tocurrency: any;
  selectedname: any;
  selectedValue: string;
  accountTransfer: FormGroup;
  accdate: FormGroup;
  reason: any;
  toAccountselectionList: any;
  fromAmount: any;
  todescription: any;
  currentlessthanfrom: boolean = false;
  fromequalto: boolean = false;
  operatingsameaccno = false;
  selectedFromAccount: any;
  selectedToAccount: any;
  selectedAccNo: any;
  accountnotequaloperation: boolean = false;
  operatingAccountNo: any;
  selectedCurrency: any;
  diffrentCurrency: boolean = false;
  toAccountNumber: boolean = false;
  pfDescriptionError: boolean = false;
  errorsameaccount: boolean = false;
  currencyData: any;
  buyCurrency: string;
  sellCurrency: string;
  exchangeRate: any;
  indirectExRate: any;
  directExRate: any;
  toCurrency: any;
  AmountTo: number;
  description: any;
  calvalue: any;
  toAccountAfterFilter: any;
  Reasonsload: Array<string> = ['Transfer', 'Funding', 'Other'];
  loadingData1: boolean = true;

  constructor(public _datepipe: DatePipe,
    public _backendService: BackendService,
    public authService: AuthService,
    public _formBuilder: FormBuilder,
    public _router: Router,
    public _notificationService: NotificationService,
    public alert: AlertmessageService,
    public _appService: AppService
  ) {

  }

  ngOnInit() {
    //var test=new Date(new Date().setDate(new Date().getDate() + 1));
    // var test1=test+1;
    // console.log(test);
    //this.today=this._datepipe.transform(new Date(new Date().setDate(new Date().getDate()+1)),"MM/dd/yyyy");
    //this.accountTransfer.controls['asofDate'].setValue(this.today);
    //this.FilterByStatus.controls['_currency'].setValue('USD')
    //this.today=
    //this.tommarrow=new FormControl(new Date(new Date().setDate(new Date().getDate() + 1)));

    this.weekOff(new Date().getDay());
    //console.log(this.today);
    this.gettingData();
    //  console.log("Account Transfer screen");

    // this.accdate=this._formBuilder.group({
    //   'asofDate':['']
    // });
    // this.today=new FormControl(new Date(new Date().setDate(new Date().getDate() -1)));
    // console.log(this.today);
    this.accountTransfer = this._formBuilder.group({
      'asofDate': [''],
      //'portfolioname':['',Validators.required],
      'operatingAcc': [''],
      //'product':[''],
      'fromCurrency': [''],
      'enterAmount': ['', Validators.required],
      'currentBalance': [''],
      'directRate': [''],
      'indirectRate': [''],
      'operatingAccTo': [''],
      'toCurrency': [''],
      'toAmount': [''],
      'reason': [''],
      //'toproduct':[''],
      'tocurrentBalance': [''],
      'comment': ['', Validators.required]
    });

    //console.log(this.asofdate);
    this.loadingData1 = true;
    this._appService.setUserLoggedIn(true);
  }
  gettingData() {
    this.loadingData1 = true;
    this._backendService.getData(`${CONFIG.getAccountTransfer}/${this.authService.CustomerID}`)
      .subscribe(response => {
        console.log(response);
        //this.portfolioData=response['portfolioData'];
        //console.log(this.portfolioData);
        this.fromAccount = response['fromAccount'];
        this.toAccount = response['toAccount'];
        this.currency = response['currencies'];
        this.reason = response['reason'];
        // console.log(response['systemdate'])
        this.asofdate = response['systemdate'];
        //  console.log(this.fromAccount,this.toAccount);
        //this.holidayList=response['holidayList'];
      });
    this.date = this.asofdate;
  }

  clear() {
    this.tocurrency = '';
    this.selectedCurrency = '';

  }
  // onSelectedPortfolio(value)
  // {
  //   console.log(value);
  //   this.name=this.portfolioData.filter(x=>x.portfolioName==value);
  //   this.selectedname=this.name[0].pfDescription;
  //   console.log(this.selectedname);
  //   if(this.selectedname==this.selectedname)
  //   {
  //     this.pfDescriptionError = true;
  //     console.log( this.pfDescriptionError );
  //     return { pfDescriptionError: true       } 
  //   }
  //   else
  //   {
  //     this.pfDescriptionError = true;
  //     console.log( this.pfDescriptionError );
  //     return { pfDescriptionError: true       } 
  //   }



  // }
  btnaccountTransferSave(Data) {
    this.loadingData1 = false;
    //  console.log(this.selectedAccBalanceList[0].product);
    // if(this.selectedAccBalanceList[0].product=="SHARE ACCOUNT"){
    //   console.log("test")
    //   //this._notificationService.showNotification({ type: 'error', message:"You must correct all errors before proceeding."});
    //   this.alert.openConfirmationDialog(" SHARE ACCOUNT does not allow to transfer");
    // }
    //console.log(Data.enterAmount,this.selectedAccBalance);
    if (parseInt(Data.enterAmount) > parseInt(this.selectedAccBalance)) {
      this._notificationService.showNotification({ type: 'error', message: "You must correct all errors before proceeding." });
    }
    else if (Data.operatingAcc == Data.operatingAccTo) {
      this._notificationService.showNotification({ type: 'error', message: "You must correct all errors before proceeding." });
    }
    else {
      // console.log(Data,Data.asofDate);

      //Data.asofDate=this.today;
      if (Data.asofDate == "")
        Data.asofDate = this._datepipe.transform(this.asofdate.toString(), "MM/dd/yyyy");


      Data.asofDate = this._datepipe.transform(Data.asofDate.toString(), "MM/dd/yyyy");

      Data.currentBalance = this.selectedAccBalance;
      Data.fromCurrency = this.selectedCurrency;
      Data.exchangerate = this.exchangeRate;
      Data.directRate = this.directExRate;
      Data.indirectRate = this.indirectExRate;
      Data.toAmount = this.AmountTo;
      Data.toCurrency = this.tocurrency;
      if (this.selectedCurrency == this.tocurrency)
        Data.exchangerate = 1;
      this._backendService.postData(Data, `${CONFIG.getAccountTransfer}/${this.authService.CustomerID}`)
        .subscribe(response => {
          console.log(response);
          if (response['result']) {
            this.loadingData1 = true;
            this._notificationService.showNotification({ type: 'success', message: response['msg'] });
          }
          else {
            this.loadingData1 = true;
            this._notificationService.showNotification({ type: 'error', message: response['msg'] });
          }
          this._router.navigate(['/dashboard']);
        });

    }
  }

  onSelectedOperatingAcc(value) {
    // let value = this.accountTransfer.controls['operatingAcc'].value;
    // console.log(value);

    this.selectedFromAccount = value;
    // console.log(this.fromAccount);
    this.selectedAccBalanceList = this.fromAccount.filter(x => x.accountingBook == value);
    this.toAccountAfterFilter = this.toAccount.filter(x => x.accountingBook != value);
    //console.log(this.toAccountAfterFilter);
    //console.log(this.selectedAccBalanceList);
    if (this.selectedAccBalanceList != null) {
      this.selectedAccBalance = this.selectedAccBalanceList[0].currentBalance;
      this.operatingAccountNo = this.selectedAccBalanceList[0].accountNo;
      this.selectedCurrency = this.selectedAccBalanceList[0].accountCurrency;
      this.description = this.selectedAccBalanceList[0].product;
    }
    // console.log(this.selectedAccBalance);
    // console.log(this.operatingAccountNo);
    if (value == this.operatingAccountNo) {

    }


  }
  toAccountNo(value) {
    this.loadingData1 = true;
    //console.log(value);
    // if(parseInt(value.length) >=11)
    // {
    this.toAccountselectionList = this.toAccount.filter(x => x.accountingBook == value);
    this.toCurrentBalance = this.toAccountselectionList[0].currentBalance;
    //this.todescription=this.toAccountselectionList[0].product;
    this.tocurrency = this.toAccountselectionList[0].accountCurrency;
    //  console.log(value,this.toCurrentBalance,this.todescription);
    this.selectedToAccount = value;

    this.currencyCalculation(this.tocurrency)
    if (this.selectedFromAccount == this.selectedToAccount) {
      this.errorsameaccount = true;
      //console.log( this.errorsameaccount );
      return { errorsameaccount: true }
    }
    else {
      this.errorsameaccount = false;
      // console.log( this.errorsameaccount );
      return { errorsameaccount: false }
    }



  }
  // toAccountNo()
  // {

  //  let  value = this.accountTransfer.controls['operatingAccTo'].value;


  //   console.log(value);
  //   if(parseInt(value.length) >=11)
  //   {
  //   this.toAccountselectionList=this.toAccount.filter(x=>x.accountingBook==value);
  //   this.toCurrentBalance=this.toAccountselectionList[0].currentBalance;
  //   this.todescription=this.toAccountselectionList[0].product;
  //   this.tocurrency=this.toAccountselectionList[0].accountCurrency;
  //   console.log(value,this.toCurrentBalance,this.todescription);
  //   this.selectedToAccount=value;
  //   }
  //   this.currencyCalculation(this.tocurrency)
  //   if(this.selectedFromAccount == this.selectedToAccount)
  //   {
  //     this.errorsameaccount = true;
  //     console.log( this.errorsameaccount );
  //     return { errorsameaccount: true } 
  //   }
  //   else
  //   {
  //     this.errorsameaccount = false;
  //     console.log( this.errorsameaccount );
  //     return { errorsameaccount: false } 
  //   }



  // }

  // enterAmount(value)
  // {

  //   console.log(value,this.selectedAccBalance);
  //   this.fromAmount=value;
  //   if( parseInt(this.fromAmount) < 1)
  //   {
  //     this.currentlessthanfrom = true;
  //     console.log( this.currentlessthanfrom );
  //     return { currentlessthanfrom: true       } 
  //   }
  //    else if( parseInt(this.selectedAccBalance) <= parseInt(this.fromAmount) )
  //    {
  //     this.currentlessthanfrom = true;
  //     console.log( this.currentlessthanfrom );
  //     return { currentlessthanfrom: true } 
  //    } 
  //   else
  //   {
  //     this.currencyCalculation(this.tocurrency);
  //     this.currentlessthanfrom = false;
  //     console.log( this.currentlessthanfrom );
  //     return { currentlessthanfrom: false       }
  //   }
  //   }
  enterAmount(value) {

    this.loadingData1 = true;
    this.fromAmount = value;
    // console.log(this.fromAmount,this.selectedAccBalance);
    if (this.fromAmount < 1) {
      this.currentlessthanfrom = true;
      //console.log( this.currentlessthanfrom );
      return {
        // currentlessthanfrom: true 
        currentlessthanfrom: true
      }
    }
    else if (this.selectedAccBalance == this.fromAmount) {
      this.currentlessthanfrom = false;
      // console.log( this.currentlessthanfrom );
      return { currentlessthanfrom: false }
    }
    else if (parseInt(this.selectedAccBalance) <= parseInt(this.fromAmount)) {
      this.currentlessthanfrom = true;
      // console.log( this.currentlessthanfrom );
      return { currentlessthanfrom: true }
    }
    else {
      this.currencyCalculation(this.tocurrency);
      this.currentlessthanfrom = false;
      //console.log( this.currentlessthanfrom );
      return { currentlessthanfrom: false }
    }
  }
  // toAmount(value)
  // {
  //   if()
  //   this.fromAmount

  // if(this.fromAmount != value)
  // {
  //   this.fromequalto = true;
  //   console.log( this.fromequalto );
  //   return { fromequalto: true       } 
  // }
  // else
  // {
  //   this.fromequalto = false;
  //   console.log( this.fromequalto );
  //   return { fromequalto: false       } 
  // }
  //}
  // onSelectedAccNo(value)
  // {
  //   console.log(value);
  //   this.selectedAccNo=value;
  //   if(this.selectedOperating!=value)
  //   {
  //     this.operatingsameaccno = true;
  //     console.log( this.operatingsameaccno );
  //     return { operatingsameaccno: true       }
  //   }

  // }
  // onSelectedOperatingAccTo(value)
  // {
  //   console.log(value);
  //   if(this.selectedFromAccount==value)
  //   {
  //     this.accountnotequaloperation = true;
  //     console.log( this.accountnotequaloperation );
  //     return { accountnotequaloperation: true       }
  //   }
  //   else
  //   {
  //     this.accountnotequaloperation = false;
  //     console.log( this.accountnotequaloperation );
  //     return { accountnotequaloperation: false       }
  //   }
  // }
  currencyCalculation(value) {
    this.loadingData1 = true;
console.log(value,"Calculation");
    this.toCurrency = value;
    if (this.selectedCurrency != value) {

      this.diffrentCurrency = true;
      this.GetExchangeRate(value);
      //this.CalculateExchangerateintoAmountTo();
      // console.log( this.diffrentCurrency );
      return { diffrentCurrency: true }
    }
    else {
      this.directExRate = 1;
      this.indirectExRate = 0;
      this.AmountTo = this.fromAmount;
      this.diffrentCurrency = false;
      // console.log( this.diffrentCurrency );
      return { diffrentCurrency: false }
    }

  }

  // onclick()
  // {
  //   console.log("on click method");
  // }

  GetExchangeRate(value) {
    this.loadingData1 = true;
 console.log(value);
    this.buyCurrency = this.selectedCurrency;
    this.sellCurrency = value;
    //console.log("In Exchange rate method");
    if (this.buyCurrency != this.sellCurrency) {
      this._backendService.getData(`${CONFIG.getAccountTransfer}/${this.buyCurrency + "/" + this.sellCurrency}`)
        .subscribe(response => {
          console.log(response);
          this.exchangeRate = response['exchangeRate'];
          if (this.selectedCurrency == "XCD") {
            this.directExRate = 1 / this.exchangeRate;
            this.indirectExRate = this.exchangeRate;
            this.CalculateExchangerateintoAmountTo(this.directExRate);
          }
          else {
            this.directExRate = this.exchangeRate;
            this.indirectExRate = 1 / this.exchangeRate;
            this.CalculateExchangerateintoAmountTo(this.directExRate);
          }

          // console.log(this.directExRate,this.indirectExRate);
        });

    }
  }
  CalculateExchangerateintoAmountTo(value) {
    // console.log(this.fromAmount);
    if (value = this.directExRate) {
      // console.log(value);
      this.AmountTo = this.fromAmount * value;
      //  console.log(this.AmountTo);
    }
    else {
      this.AmountTo = 0;
      this.AmountTo = this.fromAmount * 1;
      // console.log(this.AmountTo);
    }
  }


  onSelectToAccountNo(value) {
    // console.log(value);
    if (this.operatingAccountNo == value) {
      this.toAccountNumber = true;
      // console.log( this.toAccountNumber );
      return { toAccountNumber: true }
    }
    else {
      this.toAccountNumber = false;
      //console.log( this.toAccountNumber );
      return { toAccountNumber: false }
    }

  }

  cancel() {
    this._router.navigate(['/dashboard']);
  }

}
